import { Controller, useFieldArray } from "react-hook-form";
import { FieldProps } from "../../renderFieldInput";
import {
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
  InputLabel,
  Typography,
  Paper,
  Button,
  Unstable_Grid2 as Grid,
  IconButton,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import _ from "lodash";
import { useEffect } from "react";
import { FormatedField, TreatmentData } from "../../../../types/fields.types";
import { DateInputField } from "../DateInputField";

interface TreatmentProvidedAppointmentsFilterFieldProps extends FieldProps {}

export const TreatmentProvidedAppointmentsFilterField = ({
  field: apiField,
  value,
  entityForm,
  options,
  extraOptions,
}: TreatmentProvidedAppointmentsFilterFieldProps) => {
  const fieldName = extraOptions?.field ? extraOptions?.field : apiField.field;
  const { fields, append, remove } = useFieldArray({
    name: fieldName,
    control: entityForm.control,
    rules: {
      validate: (data: Array<unknown>) => hasDuplicateTreatments(data as Array<TreatmentData>),
    },
  });

  useEffect(() => {
    if (value) {
      entityForm.setValue(fieldName, value.treatment_provided);
    }
  }, [entityForm, fieldName, value]);

  return (
    <Paper variant="outlined" sx={{display:"flex", flexDirection:"column", gap:1, p: 2, minWidth:"400px" }}>
      <Typography marginBottom={2}>{apiField.headerName} </Typography>
      {entityForm.formState.errors.treatment_provided ? (
        <Typography mb={2} color="red">
          {entityForm.formState.errors.treatment_provided?.root?.message as string}{" "}
        </Typography>
      ) : null}
      {fields.map((item, index) => {
        return (
          <Paper key={item.id} variant="outlined" sx={{ display: "flex", mb: 1}}>
            <Grid container flexWrap="nowrap" flexGrow={1} alignItems="center" justifyContent="center" gap={1}>
              {apiField.settings?.options?.fields?.map((field) => {
                if (field.field === "treatment" || field.field === "provided_services_fulfillment" || field.field === "provided_services_state")
                  return (
                    <Grid key={field.field} flexGrow={1} flex={1}>
                      <Controller
                        name={`${fieldName}.${index}.${field.field}`}
                        control={entityForm.control}
                        defaultValue={value || ""}
                        render={({ field: inputField }) => (
                          <FormControl fullWidth error={options?.error} sx={{ m: options?.error ? 1:0 }}>
                            <InputLabel>{field.field ? handleLabel(field.field) : ""}</InputLabel>
                            <Select
                              {...inputField}
                              disabled={options?.disabled}
                              label={field.field ? handleLabel(field.field) : ""}
                            >
                              {field.meta?.options?.choices?.map((choice) => {
                                return (
                                  <MenuItem key={choice.value} value={choice.value}>
                                    {choice.text}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                            <FormHelperText sx={{display: options?.helperText ? "block" : "none"}}>{options?.helperText}</FormHelperText>
                          </FormControl>
                        )}
                      />
                    </Grid>
                  );
                return (
                  <Grid key={field.field} flexGrow={1} flex={1}>
                    <DateInputField
                      field={field as FormatedField}
                      value={value}
                      entityForm={entityForm}
                      extraOptions={{
                        field: `${fieldName}.${index}.${field.field}`,
                      }}
                      options={options}
                    />
                  </Grid>
                );
              })}
              <Grid>
                <IconButton type="button" onClick={() => remove(index)}>
                  <Delete />
                </IconButton>
              </Grid>
            </Grid>
          </Paper>
        );
      })}
      <Button
        sx={{ mt: 2 }}
        type="button"
        onClick={() =>
          append({
            treatment: "",
          })
        }
      >
        Adicionar
      </Button>
    </Paper>
  );
};

const hasDuplicateTreatments = (data: TreatmentData[]) => {
  const uniqueTreatments = _.uniqBy(data, "treatment");

  if (uniqueTreatments?.length !== data?.length && data) {
    // If lengths are different, then there are duplicates
    return "Não pode usar o mesmo tratamento mais do que uma vez";
  }
};

const handleLabel = (field: string) => {
  if (field === "treatment") return "Tratamento"
  if (field === "provided_services_state") return "Estado"
  if (field === "provided_services_fulfillment") return "Opção"
  else return "Data"
};
